export default {
    init() {
        // menu
        (function () {
            var body = $('body'),
                pureCssCheckboxLabel = $('#pure-css-navigation-checkbox-label'),
                pureCssCheckboxOverlay = $('#pure-css-navigation-overlay'),
                navigationItems = $('#pure-css-navigation-holder a, #pure-css-navigation-holder button');

            // check the body width if over 1440
            if (body.width() < 1470) {
                body.removeClass('menu-open-1470')
            }

            pureCssCheckboxLabel.on('click', function () {
                if (body.hasClass('menu-open-1470')) {
                    body.removeClass('menu-open-1470')
                } else {
                    body.toggleClass('menu-open')
                }
            });

            pureCssCheckboxOverlay.on('click', function () {
                if (body.hasClass('menu-open-1470')) {
                    body.removeClass('menu-open-1470')
                } else {
                    body.removeClass('menu-open')
                }

                updateTabIndexes();
            });

            /**
             * Update tab indexes for navigation items
             * (a, button) so user can't tab into them
             * when hidden
             */
            function updateTabIndexes()
            {
                setTimeout(function () {
                    if ($('body').is('.menu-open-1470, .menu-open')) {
                        navigationItems.attr('tabindex', '0');
                    } else {
                        navigationItems.attr('tabindex', '-1');
                    }
                }, 300);
            }
        })();

        // open the modal if the page has the class js-open-location-switch-modal open up the modal
        (function () {

            var body = $('body'),
                locationModal = $('#locationSwitchModal');

            if (body.hasClass('js-open-location-switch-modal')) {
                locationModal.modal('show');
            }

        }());
    },
    finalize() {
        // back to top button
        (function () {
            var backToTopButton = $('#back-to-top-button'),
                bodyHtml = $('body,html');

            backToTopButton.on('click', function () {
                bodyHtml.animate({
                    scrollTop: 0,
                }, 500);
            });
        })();

        // search button
        (function () {
            var body = $('body'),
                searchButton = $('#search-button');

            searchButton.on('click', function () {
                body.toggleClass('search-open')
            });
        })();

        // change location
        (function () {
            var changeLocationSelect = $('#change-sites-location-select'),
                changeLocationButton = $('#change-sites-location-button');

            changeLocationButton.on('click', function () {
                var url = changeLocationSelect.val();

                if (url != '') {
                    window.location.href = url;
                } else {
                    alert('Please select a valid location');
                }
            });
        })();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js